import React from 'react';

/**
 * THE inside of a collapsible GROUP HEADER: a chevron that points down when the
 * group is open and right when it is collapsed, then the group's label and its
 * row count — `Label (N)`. Extracted 2026-10-02 from the Gag Breakdown's group
 * header (`gags/GagGroupTable.js`) when My Tasks grouped its Team tasks and My
 * tasks lists the same way (owner ruling: collapsed group headers with the
 * tasks inside), so the two pages cannot drift into two looks for one control.
 *
 * It renders CONTENT ONLY — no button, no wrapper, no click handler. Each caller
 * owns its own toggle element, its dirty-guard and its own `aria-expanded`,
 * because those genuinely differ (the Breakdown's header is a sticky card head
 * with a three-way prompt; My Tasks' is a table row / list header that refuses
 * and pulses). Put this inside a `<button type="button" aria-expanded>`.
 *
 * `label` may be a node; `count`, when given, is rendered as ` (N)` after it.
 * `truncate` (opt-in, default off — the Breakdown is byte-identical) ellipses
 * the label on one line, for `ui/GroupedList`'s stacked phone header.
 * My Tasks omits it and renders its own summary line beside this (owner ruling
 * 2026-10-02: "8 tasks · 2 blocked · next due 14 Oct").
 */
export default function GroupToggleLabel({ open, label, count, truncate = false }) {
  return (
    <>
      <svg
        className={`h-4 w-4 shrink-0 text-gray-500 dark:text-gray-400 transition-transform ${open ? '' : '-rotate-90'}`}
        fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
        aria-hidden="true"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
      <span className={`text-sm font-bold text-gray-800 dark:text-gray-200${truncate ? ' truncate min-w-0' : ''}`}>
        {label}{count != null && ` (${count})`}
      </span>
    </>
  );
}
